import styled from "styled-components";
import {StyledProps} from "../theme";
import {zfill} from "../utils";
import {calendar} from "../proto/compiled";

const SlotContainer = styled.a`
    display: block;
    background: white;
    border-radius: 4px;
    padding: 16px 20px;
    cursor: pointer;
    transition: box-shadow 0.2s ease, outline 0.2s ease;
    outline: 2px solid transparent;
    min-width: 200px;
    text-decoration: none;

    &:hover {
        outline: 2px solid ${({theme}: StyledProps) => theme.primary};
    }
`;

const DateText = styled.div`
    font-size: 20px;
    font-weight: 700;
    color: ${({theme}: StyledProps) => theme.content};
    white-space: nowrap;
`;

const FreePlacesText = styled.div`
    font-size: 16px;
    font-weight: 400;
    color: ${({theme}: StyledProps) => theme.content};
    margin-top: 4px;
`;

const DayText = styled.div`
    font-size: 14px;
    font-weight: 400;
    color: ${({theme}: StyledProps) => theme.content};
    margin-top: 2px;
`;

interface TerminiSlotProps {
    lecture: calendar.IAvailableLecture;
    href: string;
}

export const TerminiSlot = ({lecture, href}: TerminiSlotProps) => {
    const dates = lecture.dateTimes?.map(d => new Date(d.ts as number)) ?? [];
    const hasMultipleDays = dates.length > 1;

    if (hasMultipleDays) {
        return (
            <SlotContainer
              href={href}
              target="_top"
              rel={"noopener"}
            >
                {dates.map((date, index) => (
                    <DayText key={`${date.getTime()}-${index}`}>
                        <b>{index + 1}. dan:</b> {date.getDate()}.{date.getMonth() + 1}.{date.getFullYear()} ob {date.getHours()}.{zfill(date.getMinutes(), 2)}
                    </DayText>
                ))}
                <FreePlacesText>Prosta mesta: <b>{lecture.freePlaces}</b></FreePlacesText>
            </SlotContainer>
        );
    }

    const date = dates[0] ?? new Date(lecture.dateTime!.ts as number);

    return (
        <SlotContainer
          href={href}
          target="_top"
          rel="noopener"
        >
            <DateText>
                {date.getDate()}.{date.getMonth() + 1}.{date.getFullYear()} ob {date.getHours()}.{zfill(date.getMinutes(), 2)}
            </DateText>
            <FreePlacesText>Prosta mesta: <b>{lecture.freePlaces}</b></FreePlacesText>
        </SlotContainer>
    );
};
